export const capitalize = (str) =>
  str && str.split("")[0].toUpperCase() + str.slice(1);
